import React from 'react';
import * as S from './style';
import { FormStatusInfo, Btn, Label } from 'components';
import { ReactComponent as ImgReject } from 'assets/img/status/img_doc_reject.svg';
import { ReactComponent as CheckOn } from 'assets/img/common/btn_checkbox_on.svg';
import { ReactComponent as CheckOff } from 'assets/img/common/btn_checkbox_off.svg';
import { ReactComponent as CheckWarn } from 'assets/img/common/btn_checkbox_warn.svg';
import { ReactComponent as GrayArrow } from 'assets/img/common/ic_right_arrow_gray.svg';
import { ReactComponent as BlueArrow } from 'assets/img/common/ic_right_arrow_blue.svg';
import { ReactComponent as RedArrow } from 'assets/img/common/ic_right_arrow_red.svg';

interface Props {
  rjectInfoList: Array<string>;
  documentDenialComment?: string;
  isActive?: boolean;
  buttons?: Array<{
    name: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    checked: boolean;
  }>;
  onClickApproveCheck: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  memberValid?: boolean;
  profileImageValid?: boolean;
}

function ApproveReject({
  rjectInfoList,
  documentDenialComment,
  isActive,
  buttons,
  memberValid,
  profileImageValid,
  onClickApproveCheck,
}: Props): React.ReactElement {
  return (
    <FormStatusInfo
      subTitle={['재확인 요청드립니다.', '안내 내용을 확인해주세요.']}
      image={<ImgReject />}
      btn={
        <Btn
          height={64}
          fontStyle={'body1_bold'}
          backGroundColor={isActive ? 'blue_900' : 'gray_opacity_200'}
          color={isActive ? 'gray_opacity_50' : 'gray_opacity_300'}
          onClick={onClickApproveCheck}
        >
          {'최종승인 신청'}
        </Btn>
      }
      inHomeBtn={true}
    >
      <S.CaptionWrapper>
        안녕하세요. 기사님! 최종승인 심사 과정 중 재확인을 요청드릴 사항이 있어
        안내드립니다.
        <br />
        아래 안내 메시지를 참고하여 정보를 다시 등록해주세요.
        <br />
      </S.CaptionWrapper>
      <S.RejectWrapper>
        {rjectInfoList.map((item, index) => (
          <Label
            key={index}
            contents={`- ${item}`}
            fontStyle={'caption'}
            color={'red_900'}
          />
        ))}
      </S.RejectWrapper>
      <S.GuideWrapper>{documentDenialComment}</S.GuideWrapper>
      <S.BtnInterviewWrapper>
        {buttons?.map((item, index) => (
          <Btn
            key={index}
            backGroundColor={
              (memberValid === false && item.name === '직원 등록하기') ||
              (profileImageValid === false &&
                item.name === '대표 프로필 만들기')
                ? 'red_opacity_100'
                : 'gray_opacity_50'
            }
            boarderColor={
              (memberValid === false && item.name === '직원 등록하기') ||
              (profileImageValid === false &&
                item.name === '대표 프로필 만들기')
                ? 'red_900'
                : item.checked
                ? 'blue_900'
                : 'gray_opacity_200'
            }
            color={
              (memberValid === false && item.name === '직원 등록하기') ||
              (profileImageValid === false &&
                item.name === '대표 프로필 만들기')
                ? 'red_900'
                : item.checked
                ? 'blue_900'
                : 'gray_opacity_600'
            }
            fontStyle={'body2'}
            height={52}
            onClick={item.onClick}
          >
            <S.BtnContentsContainer>
              <S.BtnContentsWrapper>
                {(memberValid === false && item.name === '직원 등록하기') ||
                (profileImageValid === false &&
                  item.name === '대표 프로필 만들기') ? (
                  <CheckWarn />
                ) : item.checked ? (
                  <CheckOn />
                ) : (
                  <CheckOff />
                )}{' '}
                {item.name}
              </S.BtnContentsWrapper>
              {(memberValid === false && item.name === '직원 등록하기') ||
              (profileImageValid === false &&
                item.name === '대표 프로필 만들기') ? (
                <RedArrow />
              ) : item.checked ? (
                <BlueArrow />
              ) : (
                <GrayArrow />
              )}
            </S.BtnContentsContainer>
          </Btn>
        ))}
      </S.BtnInterviewWrapper>
    </FormStatusInfo>
  );
}

export default ApproveReject;
